


























































































import Vue from "@/shared/node_modules/vue";
import Component from "@/shared/node_modules/vue-class-component";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings } from "@/shared/core/services/configService";
import InputText from "@/shared/components/form/inputText.vue";
import SubmitButton from "@/shared/components/submitButton/submitButton.vue";

@Component({
  components: {
    InputText,
    SubmitButton,
  },
})
export default class TreasurePage extends Vue {
  private treasure: any = {};
  error: string = "";
  ok: string = "";
  errors: any = {};
  showDownloadButton: boolean = false;

  async created() {
    const treasureId = this.$route.params.treasureId;
    if (treasureId) {
      await this.loadTreasureData(treasureId);
    }
  }

  private async loadTreasureData(treasureId: string) {
    const url = `${Settings.HostName}/api/PublicTreasureRequests/${treasureId}`;
    const response = await new CrudService().httpGet(url);
    if (response) {
      this.treasure = response;
    }
  }

  cleanErrors() {
    this.errors = {};
    this.error = "";
  }

  async pdf(e: any) {
    e.preventDefault();
    this.error = "";

    const treasureId = this.$route.params.treasureId;
    const url = `${Vue.prototype.$hostname}/api/publictreasurerequests/download-invoice/${treasureId}`;
    const response = await new CrudService().httpPost(url);
    if (response != null && response.ok === false) {
      this.error = response.errorMsg;
    }
  }

  async save(e: any) {
    e.preventDefault();
    this.cleanErrors();
    this.ok = "";

    const url = `${Settings.HostName}/api/PublicTreasureRequests/modify-customer`;
    const data = await new CrudService().httpPut(url, this.treasure);

    if (data == null || data.ok === false || data.ok === undefined) {
      this.error = this.$t("GenericError").toString();
      this.showDownloadButton = false;
      return;
    }

    this.ok = this.$t("Data modified!").toString();
    this.showDownloadButton = true;
  }
}
